import { createReducer } from 'typesafe-actions'
import { fetchCustomButtonsByCompanyHandle } from './handles'
import { CustomButtonAction, CustomButtonState } from './types'

const initialState: CustomButtonState = {
  customButtons: [],
  isErrorFetchCustomButtonsByCompany: false,
  isLoadingFetchCustomButtonsByCompany: false,
  isSuccessFetchCustomButtonsByCompany: false
}

export const customButtonReducer = createReducer<CustomButtonState, CustomButtonAction>(initialState)
  .handleAction(fetchCustomButtonsByCompanyHandle.asyncAction.failure, fetchCustomButtonsByCompanyHandle.failure)
  .handleAction(fetchCustomButtonsByCompanyHandle.asyncAction.success, fetchCustomButtonsByCompanyHandle.success)
  .handleAction(fetchCustomButtonsByCompanyHandle.asyncAction.request, fetchCustomButtonsByCompanyHandle.request)
